import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelService } from '@lib/services';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedPeerToPeerConfirmationComponent } from './shared-peer-to-peer-confirmation.component';

@NgModule({
    declarations: [SharedPeerToPeerConfirmationComponent],
    imports: [CommonModule, AngularMaterialModule],
    providers: [SidePanelService],
    exports: [AngularMaterialModule],
})
export class SharedPeerToPeerConfirmationModule {}
